﻿import {useEffect, useMemo, useState} from "react";
import {useGeocodeByLatLng} from "../maps/useGeocodeByLatLng";
import {LocationSearchParams} from "./useLocationSearchParams";

export const useGeocodedPlaceByBrowserLatLng = ({currentPlace, shouldTryBrowserLatLng, currentLocationParams}: {currentPlace: any, shouldTryBrowserLatLng: boolean, currentLocationParams: LocationSearchParams | undefined}) => {
    const [failedToGetByBrowserLatLng, setFailedToGetByBrowserLatLng] = useState<boolean>(false);
    const [latitude, setLatitude] = useState<number | undefined>();
    const [longitude, setLongitude] = useState<number | undefined>();
    const {geocodedPlace, geocodingError} = useGeocodeByLatLng({latitude, longitude});

    const browserPositionsFailedOrGeocodingFailed = useMemo(() => {
        return failedToGetByBrowserLatLng || geocodingError
    }, [failedToGetByBrowserLatLng, geocodingError]);

    // reset failure if params change
    useEffect(() => {
        if (currentLocationParams) {
            setFailedToGetByBrowserLatLng(false);
        }
    }, [currentLocationParams]);

    // if geocodedPlace was acquired, it didn't fail
    useEffect(() => {
        if (geocodedPlace) {
            setFailedToGetByBrowserLatLng(false);
        }
    }, [geocodedPlace]);

    // if failed to get by local storage, try browser geolocation
    useEffect(() => {
        if (window.navigator.geolocation) {
            // maybe check currentPlace loading
            if (shouldTryBrowserLatLng && !currentPlace && (!currentLocationParams?.city || !currentLocationParams?.state)) {
                // If a user gives location permissions to our app
                window.navigator.permissions.query({name: "geolocation"}).then((result) => {
                    if (result.state === "granted") {
                        window.navigator.geolocation.getCurrentPosition((position) => {
                            setLatitude(position.coords.latitude);
                            setLongitude(position.coords.longitude);
                        }, () => {
                            setFailedToGetByBrowserLatLng(true);
                        });
                    } else {
                        setFailedToGetByBrowserLatLng(true);
                    }
                }).catch(error => {
                    setFailedToGetByBrowserLatLng(true);
                    console.error(error)
                })
            }
        } else {
            setFailedToGetByBrowserLatLng(true)
        }
    }, [currentLocationParams, currentPlace, shouldTryBrowserLatLng]);

    return {
        geocodedPlaceByBrowserLatLng: geocodedPlace,
        failedToGetByBrowserLatLng: browserPositionsFailedOrGeocodingFailed
    }
}
